import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import moment from 'moment';
import { Modal } from "react-bootstrap";
import Select from 'react-select';
import { Pagination, Tooltip } from 'antd';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'

import { useTheme } from "./theme-provider.js"
import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import StatusBadge from "../common_component/StatusBadge.js";
import approveButtonShow from '../common_component/listPageApprovalButtonShow.js';
import PageError from '../common_component/PageError.js';
import TableColumnHead from "../common_component/TableColumnHead.js";
import formatNumber from "../common_component/formatNumber.js";


const statusTypeArray = ["BILL_FINALIZED", "BILL_PENDING_APPROVAL", "BILL_CANCELLED", "BILL_DRAFT"]

function BillList() {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()

    // const history = useHistory()

    const daterange_picker_ref = useRef()
    const [statusType, setStatusType] = useState({ label: "All", value: "All" });
    // const [dateType, setDateType] = useState({ label: "All", value: "All" });

    const [billList, setBillList] = useState([])

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null)
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [dateFormat, setDateFormat] = useState(moment.utc().format("YYYY-MM-DD"))
    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [billListApiState, setBillListApiState] = useState(false)

    const [grNumbersModalShow, setGrNumbersModalShow] = useState(false)
    const [billIndex, setBillIndex] = useState(null)

    const [flowModalShow, setFlowModalShow] = useState(false)

    var page_name = "bill-list";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    async function getBillList(signal, cp, rpp, sort_c, sort_v, search_v, sd, ed, st) {
        setBillListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-bill-list`, { signal, method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "start_date": sd, "end_date": ed, "status_type": st, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation !== "success") throw "get bill list api error"
        setBillList(body.data.list)
        setListCount(body.data.count)

        setBillListApiState(false)
    }

    async function getbasecurrency() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.length > 0) {
            setDateFormat(body[0].date_format);
        } else {
            setDateFormat("ll")
        }
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    const timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                }
            }
        }
        else {
            throw "timezone api error"
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            const controller = new AbortController();
            const signal = controller.signal;

            let p1 = getTimezoneInformation()
            let p2 = getbasecurrency()
            let p3 = getBillList(signal, currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate, statusType.value)

            Promise.all([p1, p2, p3])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    if (err.name !== 'AbortError') {
                        setstate(3)
                        console.log(err)
                    }
                })

            return () => {
                controller.abort();
            };
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            const controller = new AbortController();
            const signal = controller.signal;

            getBillList(signal, currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate, statusType.value)

            return () => {
                controller.abort();
            };
        }
    }, [currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate, statusType.value])

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Bill List</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        {/* <button className="btn p-0 mx-3 btn-hover-scale">{true ? <i className="bi bi-pin-fill fs-1 px-0"></i> : <i className="bi bi-pin fs-1 px-0"></i>}</button> */}
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/purchase/bills`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        <Link to={`/create-bill`} className="btn btn-sm btn-primary me-3 rounded btn-hover-scale">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff"></path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Create New Bill</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        <DateRangePickerComponent
                                            ref={daterange_picker_ref}
                                            allowEdit={false}
                                            showClearButton={false}
                                            focus={() => { daterange_picker_ref.current.show() }}
                                            delayUpdate={true}
                                            presets={[
                                                { label: 'Today', start: new Date(), end: new Date() },
                                                { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                            ]}
                                            change={(e) => {
                                                setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                            }}
                                            startDate={new Date(startDate)}
                                            endDate={new Date(endDate)}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <Select
                                            options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x.replace("BILL", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), value: x } })]}
                                            onChange={(event) => { setStatusType(event); }}
                                            value={statusType}
                                            placeholder="Select Type..."
                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                        />
                                    </div>
                                </div>

                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                billListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    billList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    showQuickJumper={true}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                />
                                                            </div>

                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }} >
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'bill_number'} label={'Bill Number'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'due_date'} label={'Due Date'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px">Supplier</th>
                                                                            <th className="min-w-150px">GSTIN Number</th>
                                                                            <th className="min-w-150px">Grand Total</th>
                                                                            <th className="min-w-150px">Goods Received Numbers</th>
                                                                            <th className="min-w-150px">Branch</th>
                                                                            <th className="min-w-150px">Payment Status</th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'bill_date'} label={'Bill Date'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'add_status'} label={'Status'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            billList.map((obj, indx) => {
                                                                                return (
                                                                                    <tr key={obj.bill_id}>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.bill_number}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj.due_date).utcOffset(timezone_change).format(dateFormat)}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.user_type} - {obj.doc_user_name}</span></td>
                                                                                        <td><span className="badge badge-light-info">{obj.gstin_number}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.bill_currency.currency_symbol}&nbsp;{formatNumber(obj.grand_total, { ...formatNumberOptions, currencyFormat: obj.bill_currency.format, decimalPlaces: obj.bill_currency.decimal_place })}</span></td>
                                                                                        <td>{obj.goods_received_id.slice(0, 4).map((gr, i) => (<span key={gr.gr_id} className={`fw-semibold badge badge-secondary m-1`}>{gr.gr_number}</span>))}{obj.goods_received_id.length > 4 && <span className="cursor-pointer text-primary" onClick={() => { setGrNumbersModalShow(true); setBillIndex(indx) }}>...View More</span>}</td>
                                                                                        <td><span className="badge badge-light-info">{obj.branch_name}</span></td>
                                                                                        <td><span className={obj.payment_status === "Paid" ? "badge badge-success" : obj.payment_status === "Unpaid" ? "badge badge-secondary" : "badge badge-warning"}>{obj.payment_status}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj.bill_date).utcOffset(timezone_change).format(dateFormat)}</span></td>
                                                                                        <td><StatusBadge status={obj.add_status} entity={"BILL"} /></td>
                                                                                        <td className="sticky-column">
                                                                                            <div className="dropdown">
                                                                                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                                    <i className="fas fa-bars px-0"></i>
                                                                                                </button>
                                                                                                {
                                                                                                    write &&
                                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                        <li className="py-1 dropdown-item px-0"><Link className="text-black d-block px-4" to={`/view-bill/${obj.bill_id}`}>{approveButtonShow("BILL_PENDING_APPROVAL", user_role, user.email, obj) ? "View/Approve" : "View"}</Link></li>
                                                                                                        {(obj.add_status != "BILL_FINALIZED" && obj.add_status != "BILL_CANCELLED") && <li className="py-1 dropdown-item px-0"><Link className="text-black d-block px-4" to={`/edit-bill/${obj.bill_id}`}>Edit details</Link></li>}
                                                                                                        {(obj.add_status === "BILL_FINALIZED") && <li className="py-1 dropdown-item px-0"><Link className="text-black d-block px-4" to={{ pathname: "/make-payment", state: { billId: obj.bill_id } }}>Make Payment</Link></li>}
                                                                                                    </ul>
                                                                                                }
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button> */}
                                                        </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>

            </div>

            <Modal show={grNumbersModalShow} onHide={() => { setGrNumbersModalShow(false); }} size="sm" centered>
                <Modal.Header>
                    <Modal.Title>Items</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGrNumbersModalShow(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-wrap px-0 mb-2 gap-2">
                        {
                            billIndex && billList[billIndex].goods_received_id.map((obj) => (
                                <span className="badge badge-primary fs-6" key={obj.gr_id}>{obj.gr_number}</span>
                            ))
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setGrNumbersModalShow(false) }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={flowModalShow} onHide={() => { setFlowModalShow(false) }} dialogClassName="h-modal-80">
                <Modal.Header>
                    <Modal.Title>
                        <span className='text-gray-500'>Order Flow Cycle</span>
                    </Modal.Title>

                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setFlowModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <img src={'./images/flow_images/customer-order.png'} className='w-100' alt="Not yet provided" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setFlowModalShow(false) }}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default BillList;